/**
 * Usage Analytics Hooks
 *
 * T013: TanStack Query hook for AI usage analytics
 */

import { useQuery } from '@tanstack/react-query';
import { aiConfigurationService } from '../services/ai-configuration-service';
import { getCurrentUserId } from '../lib/supabase';

export const usageAnalyticsKeys = {
  all: ['usage-analytics'] as const,
  current: (month?: string) =>
    [...usageAnalyticsKeys.all, 'current', month ?? 'current'] as const,
};

export function useUsageAnalytics(month?: string) {
  return useQuery({
    queryKey: usageAnalyticsKeys.current(month),
    queryFn: async () => {
      const userId = await getCurrentUserId();
      if (!userId) {
        throw new Error('User is not authenticated');
      }
      const result = await aiConfigurationService.getUsageAnalytics(userId, month);
      if (result.error) {
        throw new Error(result.error.message);
      }
      return result.data!;
    },
    staleTime: 2 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
